import React from 'react';

function makeReadOnly(Element) {
  const output = props => {
    return React.createElement(Element, Object.assign({}, props, {editMode: false}));
  };

  output.displayName = Element & Element.displayName ? `ReadOnly(${Element.displayName})` : 'ReadOnly';
  return output;
}

import {Select, Input, Checkbox} from './index';

const ReadOnlySelect = makeReadOnly(Select);
const ReadOnlyInput = makeReadOnly(Input);
const ReadOnlyCheckbox = makeReadOnly(Checkbox);

export {
  ReadOnlySelect as Select,
  ReadOnlyInput as Input,
  ReadOnlyCheckbox as Checkbox,
};
